var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32381 23.3008C9.14905 20.9799 10.985 19.0005 13.3125 19.0005H52.2535C54.3482 19.0005 56.0881 20.6165 56.2426 22.7056L58.6825 55.7056C58.8539 58.0245 57.0187 60.0005 54.6933 60.0005H15.7974C13.7048 60.0005 11.9658 58.3876 11.8087 56.3008L9.32381 23.3008Z",
    fill: "#EDF0F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 7.00049V11.0005C44 11.5528 43.5523 12.0005 43 12.0005H37",
    stroke: "#4D55E5",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9219 35.516L43.9219 24.0857M43.9219 51.3384L43.9219 50.5117L43.9219 51.3384ZM43.9219 47.7308L43.9219 46.4395L43.9219 47.7308ZM43.9219 43.6587L43.9219 42.3673L43.9219 43.6587ZM43.9219 39.5865L43.9219 38.2952L43.9219 39.5865Z",
    stroke: "#4D55E5",
    strokeWidth: 1.5,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24.0005L39 29.0005",
    stroke: "#4D55E5",
    strokeWidth: 1.5,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24.0005L49 29.0005",
    stroke: "#4D55E5",
    strokeWidth: 1.5,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.67012 18.5852H5.75886L5.61446 16.9775C5.51703 15.8895 6.31459 15.0005 7.3875 15.0005H22.0774C23.1503 15.0005 24.1073 15.8895 24.2048 16.9775L24.3476 18.5852H52.6259C54.2345 18.5852 55.6701 19.9187 55.8163 21.5501L58.9879 57.0341C59.1341 58.6654 57.9369 60.0005 56.33 60.0005H7.37406C5.76552 60.0005 4.32992 58.6654 4.18386 57.0341L1.01208 21.5501C0.866014 19.9187 2.06158 18.5852 3.67012 18.5852Z",
    stroke: "#4D55E5",
    strokeWidth: 1.5,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3851 24.0005H61.3121C62.3628 24.0005 63.1155 25.1768 62.9854 26.6162L59 58.0005",
    stroke: "#4D55E5",
    strokeWidth: 1.5,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57 35V35C58.6569 35 60 33.6569 60 32V9C60 7.34315 58.6569 6 57 6H45C44.3509 6 43.7193 6.21053 43.2 6.6L40 9L37.2 11.1C36.4446 11.6666 36 12.5557 36 13.5V18.5",
    stroke: "#4D55E5",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIconBlue);
export default __webpack_public_path__ + "static/media/folder-icon-blue.d335d99bbe3b74183aad542d7e0fb104.svg";
export { ForwardRef as ReactComponent };